export const isCustomDomain = () => {
  return location.origin !== process.env.SYSTEME_IO_HOST
}
